export const formatToNumber = (value: number) => {
  return new Intl.NumberFormat(navigator.language, {
    maximumFractionDigits: 2,
  }).format(value);
};
